// extracted by mini-css-extract-plugin
export default {"container":"brands_container__boTRY"};